import React from 'react'

function PharmacyReports() {
  return (
    <div>Pharmacy Reports (sales, stock valuation, expiry list)</div>
  )
}

export default PharmacyReports